import { render } from "./PerviewVideoModal.vue?vue&type=template&id=30ddef65&scoped=true"
import script from "./PerviewVideoModal.vue?vue&type=script&lang=js"
export * from "./PerviewVideoModal.vue?vue&type=script&lang=js"

import "./PerviewVideoModal.vue?vue&type=style&index=0&id=30ddef65&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ddef65"]])

export default __exports__